import { mapEnumToOptions } from '@abp/ng.core';

export enum MinistryTourismVerificationType {
  LicenseNumber = 1,
  PermitNumber = 2,
}

export const ministryTourismVerificationTypeOptions = mapEnumToOptions(MinistryTourismVerificationType);
